// DS: C25L
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import UserName from '../User/BasicUserName';
import StreamedList from '../StreamedList';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import s from './Who.scss';
var biSectionMap = {
    comment: 'comments_pop_up',
    favourite: 'fave_pop_up',
};
var NUM_USERS_SHOWN = 4;
var Who = function (_a) {
    var streamId = _a.streamId, users = _a.users, total = _a.total, isFetching = _a.isFetching, isInitialized = _a.isInitialized, initialize = _a.initialize, userListType = _a.userListType, deviation = _a.deviation, deviationId = _a.deviation.deviationId, dataHook = _a.dataHook, showFavouritedByModal = _a.showFavouritedByModal;
    var t = useTranslation().t;
    var _b = useState(false), isOpen = _b[0], setOpen = _b[1];
    // init stream if needed
    useEffect(function () {
        if (!isInitialized) {
            initialize(streamId, deviationId, userListType);
        }
    }, [streamId, deviationId, userListType, isInitialized, initialize]);
    var totalToShow = Math.max(total, users.length);
    var hasOverflow = totalToShow > NUM_USERS_SHOWN;
    var isEmpty = totalToShow === 0;
    var isFetchingInitial = isFetching && users.length === 0;
    var visibleSlice = !hasOverflow || isOpen ? users : users.slice(0, NUM_USERS_SHOWN);
    var remainingCount = hasOverflow && !isOpen ? totalToShow - visibleSlice.length : 0;
    var userList = visibleSlice.map(function (user) { return (React.createElement(UserLink, { user: user, className: s['user'], key: user.userId },
        React.createElement("span", { className: s['user-avatar'] },
            React.createElement(UserAvatar, { size: 16, user: user, withLink: false })),
        React.createElement("span", { className: s['username'] },
            React.createElement(UserName, { user: user })))); });
    var onClickMore = function () {
        if (userListType === 'favourite') {
            showFavouritedByModal(deviation);
        }
        else {
            setOpen(true);
        }
    };
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: biSectionMap[userListType] } },
        React.createElement("div", { "data-hook": dataHook, className: classnames('no-theme-skin', s['root'], hasOverflow && s['overflow'], isOpen && s['open'], (isEmpty || !isInitialized || isFetchingInitial) && s['empty']) }, isFetchingInitial || !isInitialized ? (React.createElement("div", null, t('who.fetching'))) : isEmpty ? (React.createElement("div", null, t("who.empty.var." + userListType))) : isOpen ? (React.createElement(StreamedList, { className: s['list'], wrapperClassName: s['scrollable'], bottomedClassName: s['bottomed'], scrolledClassName: s['scrolled'], streamId: streamId }, userList)) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['list'] }, userList),
            hasOverflow && (React.createElement(BiButton, { className: s['more'], onClick: onClickMore, biData: {
                    evid: BiEventType.DEFAULT,
                    click_info: 'deviation.who.more',
                } }, t('who.more', { count: remainingCount }))))))));
};
Who.displayName = 'Who';
export default Who;
//# sourceMappingURL=Who.js.map